import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '../../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    selectText: {
      color: variables.richBlack,
    },
    btn: {
      minWidth: 18,
    },
  }),
);
